import { render, staticRenderFns } from "./ContentPreference.vue?vue&type=template&id=7008ca71&"
import script from "./ContentPreference.vue?vue&type=script&lang=js&"
export * from "./ContentPreference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports